var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFslLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "416px",
    height: "42px",
    viewBox: "0 0 416 42",
    style: {
      enableBackground: "new 0 0 416 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#002147;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{mask:url(#mask-2_1_);fill:#002147;}\n\t.st4{fill:#D71F28;}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st6{mask:url(#mask-4_1_);fill:#D71F28;}\n\t.st7{fill:#B5B5B5;}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.st9{mask:url(#mask-6_1_);fill:#B5B5B5;}\n\t.st10{fill:#D8D8D8;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Application-Flow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x36_---Borrowers---Finalized",
    transform: "translate(-30.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M20.2,2.2c0.2-0.7,0.5-1.5,0.7-2.2c0.3,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.9,1.4c0.2,0.7,0.5,1.5,0.7,2.3c-0.6-0.5-1.2-0.9-1.9-1.4C20.3,5,19.7,5.4,19,5.9c0.2-0.8,0.5-1.5,0.7-2.3 c-0.6-0.5-1.2-0.9-1.9-1.4C18.6,2.2,19.4,2.2,20.2,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M11.5,1.3C11.7,1.2,12,1.1,12.2,1c0.1,0.4,0.3,0.8,0.4,1.3c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.9,1.4c0.2,0.8,0.5,1.5,0.7,2.3c-0.6-0.5-1.2-0.9-1.9-1.4C11.3,5,10.7,5.4,10,5.9c0.2-0.8,0.5-1.5,0.7-2.2 c-0.5-0.4-0.9-0.7-1.4-1.1c0.5-0.5,1.2-0.3,1.8-0.3C11.3,1.9,11.3,1.6,11.5,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st0",
    d: "M11.2,10.7c0.2-0.7,0.5-1.5,0.7-2.2c0.3,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.8,1.4c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.9-1.4c-0.6,0.5-1.2,0.9-1.9,1.4 c0.2-0.8,0.5-1.5,0.7-2.2c-0.6-0.5-1.2-0.9-1.8-1.4C9.7,10.7,10.4,10.7,11.2,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st0",
    d: "M20.2,10.7c0.2-0.7,0.5-1.5,0.7-2.2c0.3,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.8,1.4c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.9-1.4c-0.6,0.5-1.2,0.9-1.9,1.4 c0.2-0.8,0.5-1.5,0.7-2.2c-0.6-0.5-1.2-0.9-1.8-1.4C18.7,10.7,19.4,10.7,20.2,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st0",
    d: "M1.7,11.9c0.4-1,0.9-1.9,1.4-2.8c0.2,0.5,0.3,1.1,0.5,1.6c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.8,1.4c0.2,0.8,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.9-1.4c-0.6,0.5-1.2,0.9-1.9,1.4 C1.2,13.5,1.6,12.7,1.7,11.9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 16.963296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5.9,
    height: 5.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5.9,
    height: 5.9,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_1_",
    className: "st2",
    points: "0,0 5.9,0 5.9,5.9 0,5.9  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "st3",
    d: "M2.9,0c0.3,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0C5.3,2.8,4.7,3.2,4,3.7 c0.2,0.7,0.5,1.5,0.7,2.2C4.1,5.5,3.5,5,2.9,4.5C2.3,5,1.7,5.5,1,5.9c0.2-0.7,0.5-1.5,0.7-2.2C1.2,3.2,0.5,2.8,0,2.3 c0.7,0,1.5,0,2.2,0C2.4,1.5,2.6,0.8,2.9,0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    className: "st0",
    d: "M11.9,17c0.3,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0c-0.6,0.5-1.2,0.9-1.8,1.4 c0.2,0.8,0.5,1.5,0.7,2.3c-0.6-0.5-1.2-0.9-1.9-1.4c-0.6,0.5-1.2,0.9-1.9,1.4c0.2-0.7,0.5-1.5,0.7-2.2 c-0.6-0.5-1.2-0.9-1.9-1.4c0.8,0,1.5,0,2.3,0C11.4,18.5,11.6,17.8,11.9,17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    className: "st0",
    d: "M20.2,19.2c0.3-0.7,0.4-1.5,0.7-2.2c0.3,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.9,1.4c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.4-1.2-0.9-1.9-1.4c-0.6,0.5-1.2,0.9-1.9,1.4 c0.2-0.7,0.5-1.5,0.7-2.2c-0.6-0.5-1.2-0.9-1.9-1.4C18.6,19.2,19.4,19.2,20.2,19.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    className: "st4",
    d: "M29.6,0.9c0.2,0.1,0.5,0.2,0.7,0.3c0.1,0.3,0.2,0.7,0.3,1c0.6,0,1.4-0.1,1.9,0.3 c-0.5,0.4-1,0.7-1.5,1.1c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.9-1.4c-0.6,0.5-1.2,0.9-1.8,1.4c0.2-0.7,0.5-1.5,0.7-2.2 c-0.6-0.5-1.2-0.9-1.8-1.4c0.8,0,1.5,0,2.3,0C29.3,1.8,29.5,1.4,29.6,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    className: "st4",
    d: "M29.2,10.7c0.2-0.7,0.5-1.5,0.7-2.2c0.2,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.8,1.4c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.9-1.4c-0.6,0.5-1.2,0.9-1.8,1.4 c0.2-0.7,0.5-1.5,0.7-2.2c-0.6-0.5-1.2-0.9-1.8-1.4C27.7,10.7,28.4,10.7,29.2,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    className: "st4",
    d: "M38.2,10.7c0.2-0.6,0.4-1.2,0.6-1.7c0.5,0.9,1,1.9,1.5,2.9c0,0.1-0.1,0.2-0.1,0.3 c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.8-1.4c-0.6,0.5-1.2,0.9-1.9,1.4c0.2-0.7,0.5-1.5,0.7-2.2 c-0.6-0.5-1.2-0.9-1.8-1.4C36.7,10.7,37.4,10.7,38.2,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    className: "st4",
    d: "M29.2,19.3c0.2-0.7,0.5-1.5,0.7-2.2c0.2,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.8,1.4c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.8-1.4c-0.6,0.5-1.2,0.9-1.8,1.4 c0.2-0.7,0.5-1.5,0.7-2.2c-0.6-0.5-1.2-0.9-1.8-1.4C27.7,19.2,28.4,19.2,29.2,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    className: "st4",
    d: "M38.9,17c0.2,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0c-0.6,0.5-1.2,0.9-1.8,1.4 c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.8-1.4c-0.6,0.5-1.2,0.9-1.8,1.4c0.2-0.7,0.5-1.5,0.7-2.2 c-0.6-0.5-1.2-0.9-1.8-1.4c0.8,0,1.5,0,2.3,0C38.4,18.5,38.7,17.8,38.9,17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    className: "st4",
    d: "M11.2,27.8c0.2-0.7,0.5-1.5,0.7-2.2c0.2,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.8,1.4c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.8-1.4c-0.6,0.5-1.2,0.9-1.9,1.4 c0.2-0.7,0.5-1.5,0.7-2.2c-0.6-0.5-1.2-0.9-1.8-1.4C9.7,27.8,10.4,27.8,11.2,27.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-30",
    className: "st4",
    d: "M20.2,27.8c0.2-0.7,0.4-1.5,0.7-2.2c0.2,0.7,0.5,1.4,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.8,1.4c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.9-1.4c-0.6,0.5-1.2,0.9-1.8,1.4 c0.2-0.7,0.5-1.5,0.7-2.2c-0.6-0.5-1.2-0.9-1.9-1.4C18.7,27.7,19.4,27.8,20.2,27.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-32",
    className: "st4",
    d: "M29.2,27.8c0.3-0.7,0.5-1.5,0.7-2.2c0.2,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.9,1.4c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.9-1.4c-0.6,0.5-1.2,0.9-1.8,1.4 c0.2-0.7,0.5-1.5,0.7-2.2c-0.6-0.5-1.2-0.9-1.8-1.4C27.7,27.8,28.4,27.7,29.2,27.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-34",
    className: "st4",
    d: "M38.1,27.7c0.3-0.7,0.5-1.5,0.8-2.2c0.2,0.7,0.5,1.5,0.7,2.2h0.8c-0.3,0.8-0.7,1.7-1.2,2.5 c-0.1-0.1-0.3-0.2-0.3-0.2c-0.6,0.5-1.2,0.9-1.8,1.4c0.2-0.7,0.5-1.5,0.7-2.2c-0.6-0.5-1.2-0.9-1.8-1.4 C36.6,27.7,37.4,27.8,38.1,27.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-36",
    className: "st4",
    d: "M11.2,36.3c0.2-0.7,0.5-1.5,0.7-2.2c0.2,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.8,1.4c0.2,0.7,0.4,1.4,0.6,2.1c-0.7-0.3-1.2-0.8-1.8-1.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.3-0.2-0.7-0.3-1-0.5 c0.1-0.2,0.1-0.4,0.2-0.6c-0.6-0.5-1.2-0.9-1.8-1.4C9.7,36.3,10.4,36.3,11.2,36.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(17.827715, 33.892135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-39"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 0.1,
    y: 0.1,
    width: 6,
    height: 5.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.1,
    y: 0.1,
    width: 6,
    height: 5.9,
    id: "mask-4_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3_1_",
    className: "st2",
    points: "0.1,0.1 6,0.1 6,6 0.1,6  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-38",
    className: "st6",
    d: "M2.4,2.4c0.2-0.7,0.5-1.5,0.7-2.2c0.2,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 C5.4,2.8,4.8,3.3,4.2,3.8C4.4,4.5,4.7,5.2,4.9,6C4.3,5.5,3.7,5.1,3.1,4.6C2.4,5.1,1.8,5.5,1.2,6c0.2-0.7,0.5-1.5,0.7-2.2 C1.3,3.3,0.7,2.8,0.1,2.4C0.8,2.4,1.6,2.4,2.4,2.4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    className: "st4",
    d: "M29.2,36.3c0.2-0.8,0.5-1.5,0.7-2.2c0.2,0.7,0.5,1.5,0.7,2.2c0.8,0,1.5,0,2.3,0 c-0.6,0.5-1.2,0.9-1.8,1.4c0.1,0.2,0.1,0.4,0.2,0.6c-0.3,0.2-0.7,0.3-1,0.5c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6,0.4-1.2,0.9-1.8,1.3 c0.2-0.7,0.4-1.4,0.7-2.1c-0.6-0.5-1.2-0.9-1.8-1.4C27.7,36.3,28.4,36.3,29.2,36.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-90",
    className: "st4",
    d: "M2.2,27.7c0.2-0.7,0.5-1.5,0.7-2.2c0.3,0.7,0.4,1.5,0.8,2.2c0.7,0,1.5,0,2.2,0 c-0.6,0.5-1.2,0.9-1.9,1.4c0.2,0.7,0.5,1.5,0.7,2.2c-0.6-0.5-1.2-0.9-1.8-1.4c-0.1,0-0.2,0.1-0.2,0.2c-0.4-0.8-0.8-1.6-1.1-2.4 C1.8,27.8,2,27.7,2.2,27.7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-43",
    className: "st0",
    d: "M54.3,5.2c1,0,2,0,2.9,0c0,9.3,0,18.5,0,27.8c-1,0-2,0-2.9,0V5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-45",
    className: "st0",
    d: "M112.5,15.7c-1.4,0.3-2.7,1.1-3.6,2.2c-1.3,1.5-1.7,3.6-1.7,5.5c0.1,2,0.8,4.1,2.3,5.5 c1.2,1.2,2.9,1.8,4.6,1.8c2.1,0,4.1-1.2,5.4-2.9c1.3-1.7,1.7-3.9,1.4-6c-0.3-2.1-1.4-4-3.2-5.2 C116.2,15.7,114.3,15.3,112.5,15.7 M120.9,5.2c1,0,2,0,2.9,0c0,9.3,0,18.5,0,27.8h-2.9c0-1.3,0-2.6,0-3.9 c-1.1,1.7-2.7,3.2-4.7,3.9c-2.5,0.8-5.3,0.5-7.5-0.9c-2.2-1.4-3.8-3.7-4.3-6.3c-0.5-2.2-0.4-4.6,0.4-6.7c0.7-2,2.1-3.7,3.8-4.8 c2.3-1.5,5.4-1.8,8-0.8c1.7,0.7,3.1,2,4.2,3.5C120.9,13,120.9,9.1,120.9,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-47",
    className: "st0",
    d: "M128.9,5.7c1.1,0,2.2,0,3.4,0c0,1.1,0,2.2,0,3.3c-1.1,0-2.2,0-3.4,0 C128.9,7.9,128.9,6.8,128.9,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-49",
    className: "st0",
    d: "M67.5,16.3c-1.9,1.3-2.9,3.5-3.1,5.7c4.1,0,8.3,0,12.4,0c-0.2-1.8-0.8-3.7-2.1-5.1 C72.8,15.1,69.6,14.9,67.5,16.3 M66.1,14.1c2.3-1.4,5.2-1.6,7.7-0.8c1.9,0.6,3.5,2.1,4.5,3.8c1.2,2.1,1.6,4.7,1.5,7.1 c-5.1,0-10.2,0-15.4,0c0.2,2.1,1.2,4.2,3,5.4c1.7,1.2,4.1,1.4,6.1,0.9c1.5-0.4,2.8-1.4,3.9-2.5c0.6,0.6,1.2,1.1,1.8,1.7 c-1.4,1.7-3.3,3-5.5,3.4c-2.3,0.5-4.8,0.3-7-0.8c-2.2-1.1-3.9-3.1-4.7-5.5c-0.9-2.6-0.8-5.5,0.2-8C62.9,17,64.3,15.2,66.1,14.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-51",
    className: "st0",
    d: "M91.1,13.1c2.5-0.5,5.3-0.1,7.2,1.6c1.6,1.5,2.3,3.7,2.3,5.8c0,4.1,0,8.3,0,12.4 c-1,0-2,0-2.9,0c0-3.6,0-7.3,0-10.9c0-1.7-0.2-3.5-1.3-4.8c-1.5-1.8-4.1-2.1-6.2-1.3c-1.5,0.6-2.6,1.8-3.2,3.3 c-0.4,1.1-0.5,2.4-0.4,3.6V33c-1,0-2,0-2.9,0c0-6.6,0-13.1,0-19.7c1,0,2,0,2.9,0c0,1.1,0,2.2,0,3.4 C87.4,14.9,89.1,13.5,91.1,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-53",
    className: "st0",
    d: "M145.1,13.1c2.2-0.5,4.6-0.2,6.5,1.2c1.9,1.4,2.8,3.8,2.9,6.2c0,4.2,0,8.4,0,12.6 c-1,0-2,0-2.9,0V21.3c0-1.6-0.5-3.3-1.7-4.4c-1.8-1.6-4.5-1.7-6.6-0.6c-1.8,1-2.9,3.1-2.9,5.1V33h-2.9c0-6.6,0-13.1,0-19.7 c1,0,2,0,2.9,0c0,1.1,0,2.2,0,3.3C141.4,14.9,143.1,13.5,145.1,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-55",
    className: "st0",
    d: "M166.1,15.7c-1.5,0.3-2.8,1.2-3.7,2.4c-1.3,1.7-1.6,4-1,6.1c0.5,1.8,1.8,3.3,3.5,4.1 c3,1.4,6.9,0.4,8.8-2.2c1.1-1.4,1.5-3.3,1.1-5.1c-0.4-1.9-1.7-3.5-3.4-4.4C169.8,15.5,167.9,15.3,166.1,15.7 M162.4,14.2 c2.1-1.3,4.7-1.7,7.1-1.1c2.1,0.5,4,1.9,5.3,3.6c0-1.2,0-2.3,0-3.5c1,0,2,0,2.9,0c0,4.6,0,9.2,0,13.7c0,1.6,0.1,3.2-0.2,4.8 c-0.3,1.8-1,3.5-2.4,4.8c-1.6,1.7-4,2.4-6.3,2.5c-3.5,0.3-7.1-0.7-9.9-2.7c0.4-0.8,0.9-1.6,1.3-2.3c1.8,1.3,3.8,2.2,6,2.4 c2,0.3,4.2,0,5.9-1.1c1.3-0.9,2.1-2.3,2.4-3.8c0.3-1.4,0.1-2.8,0.2-4.2c-1,1.4-2.3,2.6-3.9,3.3c-2.3,1.1-5.1,1-7.4,0 c-2-0.9-3.7-2.5-4.6-4.5c-0.8-1.7-0.9-3.7-0.7-5.6C158.6,18,160.2,15.6,162.4,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-57",
    className: "st0",
    d: "M129.1,13.3c1,0,2,0,2.9,0c0,6.6,0,13.1,0,19.7h-2.9C129.1,26.4,129.1,19.8,129.1,13.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(272.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-59",
    className: "st0",
    d: "M6.1,1.1c1.3-0.3,2.8-0.2,4.1,0.2c0,0.7,0,1.4,0,2.1c-1-0.3-2.1-0.5-3.1-0.3 C6.4,3.3,5.8,3.8,5.5,4.5c-0.4,1-0.3,2-0.3,3c1.6,0,3.3,0,4.9,0c0,0.7,0,1.3,0,2c-1.6,0-3.3,0-4.9,0c0,4.5,0,8.9,0,13.4 c-0.8,0-1.6,0-2.3,0c0-4.5,0-8.9,0-13.4c-0.7,0-1.4,0-2.1,0c-0.1-0.7,0-1.4,0-2c0.7,0,1.4,0,2.2,0c0-1.3-0.1-2.7,0.4-3.9 C3.8,2.3,4.9,1.4,6.1,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-61",
    className: "st0",
    d: "M53.1,1.1c0.8,0,1.6,0,2.4,0c0,3,0,5.9,0,8.9c0.9-1.3,2.2-2.4,3.7-2.7c1.5-0.3,3-0.2,4.4,0.4 c1.2,0.5,2.2,1.6,2.6,2.8c0.4,1.1,0.6,2.2,0.5,3.4c0,3,0,6.1,0,9.1c-0.8,0-1.6,0-2.4,0c0-3.1,0-6.3,0-9.4 c0-1.4-0.6-2.8-1.8-3.6c-1.9-1.2-4.6-0.8-6,0.9c-0.8,0.9-1.1,2.1-1.1,3.3c0,2.9,0,5.8,0,8.8c-0.8,0-1.6,0-2.4,0 C53.1,15.6,53.1,8.3,53.1,1.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(135.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-63",
    className: "st7",
    d: "M0.2,1.1c1.2,0,2.4,0,3.6,0c0,0.3,0,0.6,0,0.9c-0.4,0-0.8,0-1.2,0c0,1.1,0,2.2,0,3.4 c-0.4,0-0.7,0-1.1,0c0-1.1,0-2.2,0-3.4H0.2C0.2,1.7,0.2,1.4,0.2,1.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-67",
    transform: "translate(4.106231, 0.954239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-66"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 0.1,
    y: 0.2,
    width: 4.3,
    height: 4.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.1,
    y: 0.2,
    width: 4.3,
    height: 4.3,
    id: "mask-6_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-5_1_",
    className: "st2",
    points: "0.1,0.2 4.4,0.2 4.4,4.5 0.1,4.5  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-65",
    className: "st9",
    d: "M0.1,0.2c0.4,0,0.7,0,1.1,0c0.4,0.6,0.7,1.1,1.1,1.7c0.3-0.6,0.7-1.1,1-1.7 c0.4,0,0.7,0,1.1,0c0,1.4,0,2.9,0,4.3c-0.3,0-0.7,0-1,0c0-0.9,0-1.7,0-2.6C3,2.4,2.6,3,2.2,3.6C1.8,3,1.5,2.4,1.1,1.8 c0,0.9,0,1.8,0,2.6c-0.3,0-0.8,0-1,0C0.1,3,0.1,1.6,0.1,0.2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-68",
    className: "st0",
    d: "M85,2.8c0.8,0,1.6,0,2.4,0c0,1.6,0,3.1,0,4.7c1.6,0,3.3,0,4.9,0c0,0.7,0,1.4,0,2.1 c-1.6,0-3.3,0-4.9,0c0,3.1,0,6.2,0,9.3c0,0.8,0.4,1.6,1.1,2c1.2,0.5,2.6,0.3,3.7-0.3c0,0.7,0,1.4,0,2c-1.4,0.7-3.1,0.8-4.6,0.4 c-0.8-0.2-1.5-0.7-2-1.4c-0.5-0.8-0.7-1.7-0.7-2.6c0-3.1,0-6.3,0-9.4h-2.1c0-0.7,0-1.4,0-2.1c0.7,0,1.4,0,2.1,0 C85,5.9,85,4.3,85,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-70",
    className: "st0",
    d: "M123.6,2.8c0.8,0,1.6,0,2.4,0c0,1.6,0,3.1,0,4.7c1.6,0,3.3,0,4.9,0c0,0.7,0,1.4,0,2.1 c-1.6,0-3.3,0-4.9,0c0,2.9,0,5.8,0,8.6c0,0.6,0,1.3,0.3,1.9c0.3,0.5,0.9,0.8,1.5,1c1,0.2,2.1,0,3.1-0.5c0,0.7,0,1.4,0,2.1 c-1.2,0.6-2.6,0.8-4,0.6c-1-0.2-2-0.6-2.5-1.5c-0.6-0.9-0.8-2.1-0.8-3.2c0-3,0-6,0-8.9c-0.7,0-1.4,0-2.1,0c0-0.7,0-1.4,0-2.1 c0.7,0,1.4,0,2.1,0C123.6,5.9,123.6,4.3,123.6,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-72",
    className: "st0",
    d: "M16.9,8.2c1.1-0.8,2.5-1.2,3.9-1.1c0,0.9,0,1.7,0,2.6c-1.5-0.1-3,0.4-4.1,1.4 c-1.5,1.2-2.1,3.1-2.2,5c-0.1,2.3,0,4.6,0,6.8c-0.8,0-1.6,0-2.4,0c0-5.2,0-10.3,0-15.5c0.8,0,1.6,0,2.4,0c0,1.3,0,2.6,0,3.9 C14.9,10.1,15.8,9,16.9,8.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-74",
    className: "st0",
    d: "M26.3,9.9c-1.4,1-2.2,2.7-2.4,4.4c3.3,0,6.6,0,9.9,0c-0.1-1.5-0.7-2.9-1.7-4 C30.6,8.8,28,8.7,26.3,9.9 M26,7.7c1.5-0.7,3.2-0.8,4.8-0.4c1.7,0.4,3.2,1.5,4.1,2.9c1.1,1.7,1.4,3.8,1.3,5.8 c-4.1,0-8.2,0-12.3,0c0.1,1.7,1,3.4,2.5,4.3c1.9,1.2,4.4,1.1,6.3-0.1c0.6-0.3,1.1-0.8,1.5-1.3c0.5,0.4,1,0.9,1.5,1.3 c-1,1.2-2.3,2.1-3.8,2.6c-2.7,0.8-5.8,0.4-7.9-1.6c-2.4-2.2-3.1-5.8-2.2-8.8C22.5,10.4,24,8.6,26,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-76",
    className: "st0",
    d: "M40.3,8.2c1.1-0.9,2.6-1.1,4-1.1c1.9,0.1,3.7,0.7,5.3,1.7c-0.3,0.6-0.7,1.2-1.1,1.8 c-1.4-0.9-2.9-1.5-4.6-1.5c-0.8,0-1.7,0.2-2.3,0.7c-0.5,0.4-0.8,1.1-0.7,1.8c0.2,0.7,0.8,1.2,1.4,1.5c1.8,0.8,3.8,1.1,5.5,2 c0.9,0.5,1.7,1.4,2,2.4c0.1,1.1,0.1,2.2-0.5,3.1c-0.8,1.4-2.3,2.1-3.8,2.4c-2.7,0.4-5.5-0.5-7.7-2.2c0.3-0.6,0.8-1.2,1.2-1.7 c1.3,0.9,2.8,1.7,4.4,1.9c1.2,0.2,2.4,0.1,3.4-0.7c0.8-0.7,1.1-2,0.3-2.8c-0.8-0.8-2-1.1-3.1-1.5c-1.6-0.5-3.5-0.9-4.7-2.2 C38,12.3,38.5,9.5,40.3,8.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-78",
    className: "st0",
    d: "M71.5,8.4c1.1-0.9,2.6-1.3,4-1.2c1.9,0.1,3.9,0.7,5.5,1.7c-0.4,0.6-0.7,1.2-1.1,1.8 c-1.2-0.8-2.6-1.3-4-1.5c-1-0.1-2.2,0.1-3,0.9c-0.6,0.6-0.8,1.8-0.1,2.5c0.8,0.7,1.9,1,3,1.4c1.6,0.5,3.3,0.9,4.5,2 c1.5,1.5,1.3,4.1-0.1,5.6c-1.1,1.2-2.9,1.7-4.5,1.7c-2.3-0.1-4.6-0.9-6.4-2.3c0.4-0.6,0.8-1.1,1.2-1.7c1.1,0.8,2.4,1.5,3.7,1.8 c1.2,0.3,2.7,0.3,3.8-0.4c0.8-0.5,1.3-1.6,0.9-2.5c-0.3-0.8-1.1-1.1-1.8-1.4c-1.8-0.7-3.8-0.9-5.5-2c-1-0.6-1.7-1.7-1.6-2.9 C70,10.4,70.5,9.2,71.5,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-80",
    className: "st0",
    d: "M97.3,16.3c-1,1.1-0.9,3,0.2,4c1.1,0.9,2.6,1.2,4,0.9c1.5-0.2,3-1,3.7-2.4 c0.5-0.9,0.4-2.1,0.4-3.1c-1.6-0.4-3.3-0.7-5-0.6C99.4,15.2,98.1,15.4,97.3,16.3 M95.5,8.5c2.4-1.1,5.1-1.6,7.7-1.1 c1.2,0.2,2.4,0.8,3.2,1.7c1,1.1,1.4,2.7,1.4,4.2c0,3.2,0,6.4,0,9.6c-0.8,0-1.5,0-2.3,0c0-0.7,0-1.5,0-2.2 c-1.3,1.6-3.3,2.6-5.4,2.6c-1.7,0.1-3.4-0.4-4.6-1.6c-2-1.7-1.8-5.3,0.2-6.9c1.1-0.9,2.4-1.2,3.8-1.4c2-0.2,4.1,0,6.1,0.6 c0-1-0.1-2.1-0.7-3c-0.7-1-1.9-1.5-3.1-1.7c-1.9-0.2-3.8,0.3-5.5,1.1C96,9.8,95.7,9.1,95.5,8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-82",
    className: "st0",
    d: "M114,11.2c1.1-2.4,3.6-4.3,6.3-4.1c0,0.9,0,1.7,0,2.6c-1.5,0-3,0.4-4.1,1.4 c-1.5,1.3-2.2,3.4-2.2,5.3c0,2.2,0,4.4,0,6.5c-0.8,0-1.6,0-2.4,0c0-5.2,0-10.3,0-15.5c0.8,0,1.6,0,2.4,0 C114,8.7,114,10,114,11.2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-84",
    className: "st4",
    d: "M209.7,10.9c2.2-0.8,4.6-0.8,6.8-0.2c1.8,0.4,3.5,1.3,4.9,2.5c-0.8,1.2-1.7,2.5-2.5,3.7 c-1.3-0.9-2.6-1.7-4.1-2c-1-0.2-2.1-0.3-3.1,0c-0.6,0.2-1.1,0.7-1.3,1.3c-0.1,0.6-0.1,1.3,0.4,1.7c0.5,0.5,1.1,0.7,1.8,0.9 c1.7,0.6,3.6,0.9,5.3,1.6c1.3,0.5,2.6,1.3,3.3,2.5c0.9,1.3,1,2.9,0.8,4.4c-0.2,1.5-0.9,3-2,4c-1.8,1.6-4.3,2-6.6,1.9 c-3.2-0.1-6.4-1.4-8.8-3.6c1-1.2,1.9-2.3,2.9-3.5c1.8,1.5,4.1,2.7,6.5,2.7c0.9,0,1.9-0.1,2.6-0.7c0.7-0.5,0.8-1.5,0.5-2.2 c-0.4-0.8-1.4-1.1-2.2-1.4c-2.3-0.8-4.8-1.1-6.8-2.4c-1.1-0.7-2-1.7-2.3-3c-0.5-1.8-0.4-3.9,0.6-5.5 C207.1,12.4,208.3,11.4,209.7,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-86",
    className: "st4",
    d: "M231.5,23.6c1.9,0,3.9,0,5.8,0c-1-2.4-1.9-4.8-2.9-7.2C233.4,18.8,232.5,21.2,231.5,23.6  M222.7,33c3.1-7.5,6.3-15,9.4-22.5c1.5,0,3,0,4.5,0c3.1,7.5,6.3,15,9.4,22.5c-1.7,0-3.4,0-5.1,0c-0.7-1.7-1.3-3.3-2-5 c-3.1,0-6.2,0-9.3,0c-0.6,1.7-1.3,3.3-2,5C226.1,33,224.4,33,222.7,33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-88",
    className: "st4",
    d: "M183.1,10.6c1.6,0,3.2,0,4.9,0c0,4.2,0,8.4,0,12.6c0,1.4,0.3,2.8,1.1,3.9c0.7,1,2,1.5,3.2,1.6 c1.4,0.1,2.9-0.2,3.8-1.2c1-1,1.3-2.6,1.3-4c0-4.3,0-8.6,0-12.9h4.9c0,4.4,0,8.8,0,13.2c-0.1,2.6-0.8,5.4-2.8,7.2 c-1.9,1.8-4.6,2.4-7.2,2.3c-2.5,0-5.1-0.8-6.8-2.7c-1.3-1.4-2-3.4-2.3-5.3c-0.2-1.1-0.1-2.3-0.1-3.4 C183.1,18.1,183.1,14.4,183.1,10.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-92",
    className: "st10",
    d: "M259,3.2c0.3,0,0.7,0,1,0c0,12.7,0,25.3,0,38c-0.3,0-0.7,0-1,0C259,28.5,259,15.8,259,3.2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFslLogo);
export default __webpack_public_path__ + "static/media/fsl-logo.eee03520375e44d82e39d6c3ddb44eab.svg";
export { ForwardRef as ReactComponent };